module.exports = __webpack_public_path__ + "img/red-bg.d2439eea.png";